import {
	getImageBase64,
	getBackground
	, getThemePic
} from "@/views/home/slidePPT/use/methods"
import {
	pathToBase64,
} from '@/utils'

export default async function (data) {
	const node = data.node;
	const title = node.title;
	const serial = data.num;
	const color = data.color;
	const id = Math.random().toString(36).slice(-8);
	const background = await getBackground()
	const ex2 = await getThemePic(data?.customTheme, 'ex-2')
	const ex3 = await getThemePic(data?.customTheme, 'ex-3')
	const ex4 = await getThemePic(data?.customTheme, 'ex-4')
	const ex5 = await getThemePic(data?.customTheme, 'ex-5')
	const ex6 = await getThemePic(data?.customTheme, 'ex-6')
	const ex7 = await getThemePic(data?.customTheme, 'ex-7')


	return {
		"id": id,
		"elements": [
			{
				"type": "text",
				"id": "wdf6K1lP9F",
				"width": 220.87,
				"height": 189.171875,
				"left": 100.46,
				"top": 199.53,
				"rotate": 0,
				"defaultFontName": "Microsoft Yahei",
				"defaultColor": "#333",
				"content": `<p style=\"text-align: center;\"><span style=\"font-size: 61.22px;font-family: Arial Black;\">PART</span></p><p style=\"text-align: center;\"><span style=\"font-size: 97.96px;font-family: Arial Black;\">${serial}</span></p>`,
				"lineHeight": 1,
				"outline": {
					"color": "#000",
					"width": 0,
					"style": "solid"
				},
				"fill": "",
				"vertical": false
			},
			{
				"type": "text",
				"id": "NI-ccKaW_V",
				"width": 386.17,
				"height": 56.734375,
				"left": 572.72,
				"top": 237.42,
				"rotate": 0,
				"defaultFontName": "Microsoft Yahei",
				"defaultColor": "#333",
				"content": `<p style=\"text-align: left;\"><span style=\"color: #55B577;font-size: 36.73px;font-family: 迷你简细倩;\">${title}</span></p>`,
				"lineHeight": 1,
				"outline": {
					"color": "#000",
					"width": 0,
					"style": "solid"
				},
				"fill": "",
				"vertical": false
			},
			{
				"type": "line",
				"id": "QLtlEoYClh",
				"width": 1,
				"left": 552.56,
				"top": 287.16,
				"start": [
					0,
					0
				],
				"end": [
					365.63,
					0
				],
				"style": "solid",
				"color": "#55B577",
				"points": [
					"",
					""
				]
			},
			{
				"type": "image",
				"id": "xc8SjrGt-i",
				"src": ex2,
				"width": 247.52,
				"height": 249.02,
				"left": 305.31,
				"top": 87.96,
				"fixedRatio": true,
				"rotate": 0,
				"flipH": false,
				"flipV": false
			},
			{
				"type": "image",
				"id": "K8Ekt9tZzV",
				"src": ex3,
				"width": 252.52,
				"height": 224.52,
				"left": 289.38,
				"top": 272.9,
				"fixedRatio": true,
				"rotate": 0,
				"flipH": false,
				"flipV": false
			},
			{
				"type": "image",
				"id": "qsTvmjC870",
				"src": ex4,
				"width": 353.03,
				"height": 130.51,
				"left": 8.44,
				"top": 431.87,
				"fixedRatio": true,
				"rotate": 0,
				"flipH": false,
				"flipV": false
			},
			{
				"type": "image",
				"id": "svc76IwCoi",
				"src": ex5,
				"width": 141.01,
				"height": 153.01,
				"left": -31.06,
				"top": 356.93,
				"fixedRatio": true,
				"rotate": 0,
				"flipH": false,
				"flipV": false
			},
			{
				"type": "image",
				"id": "LKjaNlw-oH",
				"src": ex6,
				"width": 268.52,
				"height": 256.02,
				"left": -120.58,
				"top": 201.03,
				"fixedRatio": true,
				"rotate": 0,
				"flipH": false,
				"flipV": false
			},
			{
				"type": "image",
				"id": "z65eiVadp7",
				"src": ex7,
				"width": 384.53,
				"height": 229.02,
				"left": -0.08,
				"top": 0.04,
				"fixedRatio": true,
				"rotate": 0,
				"flipH": false,
				"flipV": false
			}
		],
		background
	}
}